import { PermissionCheckerService } from '@abp/auth/permission-checker.service';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';

@Injectable()
export class AppNavigationService {

    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService
    ) {

    }

    getMenu(): AppMenu {
        return new AppMenu('MainMenu', 'MainMenu', [
            new AppMenuItem('Dashboard', 'Pages.Administration.Host.Dashboard', 'flaticon-line-graph', '/app/admin/hostDashboard'),
            new AppMenuItem('Dashboard', 'Pages.Tenant.Dashboard', 'flaticon-line-graph', '/app/main/dashboard'),
            new AppMenuItem('AdvancedSearch', 'Pages.AdvancedSearch', 'flaticon-search', '/app/main/advancedSearch/advanced-search'),
            new AppMenuItem('Tenants', 'Pages.Tenants', 'flaticon-list-3', '/app/admin/tenants'),
            // new AppMenuItem('CardTemplateProperties', 'Pages.CardTemplateProperties', 'flaticon-more', '/app/main/cardTemplateProperties/cardTemplateProperties'),
            // new AppMenuItem('CardTemplateValues', 'Pages.CardTemplateValues', 'flaticon-more', '/app/main/cardTemplateValues/cardTemplateValues'),
            // new AppMenuItem('NotifyJobs', 'Pages.NotifyJobs', 'flaticon-more', '/app/main/notifyJobs/notifyJobs'),




            // new AppMenuItem('CommodityGroups', 'Pages.CommodityGroups', 'flaticon-more', '/app/main/commodityGroups/commodityGroups'),

            // new AppMenuItem('BillReports', 'Pages.BillReports', 'flaticon-more', '/app/main/billReports/billReports'),

            // new AppMenuItem('FlowerCrownBranchs', 'Pages.FlowerCrownBranchs', 'flaticon-more', '/app/main/flowerCrownBranchs/flowerCrownBranchs'),

            // new AppMenuItem('PlanCurrencies', 'Pages.PlanCurrencies', 'flaticon-more', '/app/main/planCurrencies/planCurrencies'),




            // new AppMenuItem('ContactWallets', 'Pages.ContactWallets', 'flaticon-more', '/app/main/contactWallets/contactWallets'),


            new AppMenuItem('Editions', 'Pages.Editions', 'flaticon-app', '/app/admin/editions'),

            new AppMenuItem('BillsActions', '', 'flaticon-list', '', [
                new AppMenuItem('FlowerCrown', 'Pages.FollowUps' && 'Pages.FollowUps.FlowerCrown', 'flaticon-more', '/app/main/action/action'),
                new AppMenuItem('Sacrifice', 'Pages.FollowUps' && 'Pages.FollowUps.Sacrifice', 'flaticon-more', '/app/main/sacrifice-action/sacrifice-action'),
                new AppMenuItem('Ambassador', 'Pages.PostmanTasks', 'flaticon-more', '/app/main/postman-action/postman-action'),
                new AppMenuItem('Accounting', 'Pages.Accounting', 'flaticon-more', '/app/main/accounting-action/accounting-action'),
            ]),
            new AppMenuItem('Services', '', 'flaticon-layers', '', [
                new AppMenuItem('Conditions', 'Pages.Conditions', 'flaticon-more', '/app/main/conditions/conditions'),
                new AppMenuItem('Services', 'Pages.Services', 'flaticon-more', '/app/main/services/services'),
                new AppMenuItem('ServiceConditions', 'Pages.ServiceConditions', 'flaticon-more', '/app/main/serviceConditions/serviceConditions'),
                new AppMenuItem('ServicesActions', 'Pages.ServiceVouchers', 'flaticon-more', '/app/main/regulatVouchers/regulatVouchers'),
                // new AppMenuItem('جزییات خدمات دوره ای', 'Pages.VoucherDetails', 'flaticon-more', '/app/main/voucherDetails/voucherDetails'),
                new AppMenuItem('ClientFamilyCommodityBasket', 'Pages.ClientCommodityBasket', 'flaticon-more', '/app/main/stock/client-family-commodityBasket'),
                new AppMenuItem('Accounts', 'Pages.Accounts', 'flaticon-more', '/app/main/accounts/accounts'),
            ]),


            new AppMenuItem('Store', '', 'flaticon-gift', '', [
                new AppMenuItem('CommodityGroups', 'Pages.CommodityGroups', 'flaticon-more', '/app/main/commodityGroups/commodityGroups'),
                new AppMenuItem('Commodities', 'Pages.Commodities', 'flaticon-more', '/app/main/commodities/commodities'),
                new AppMenuItem('BranchCommodities', 'Pages.BranchCommodities', 'flaticon-more', '/app/main/branchCommodities/branchCommodities'),
                new AppMenuItem('CommodityBaskets', 'Pages.CommodityBaskets', 'flaticon-shopping-basket', '/app/main/commodityBaskets/commodityBaskets'),
                new AppMenuItem('TransactionTypes', 'Pages.TransactionTypes', 'flaticon-more', '/app/main/transactionTypes/transactionTypes'),
                new AppMenuItem('StockTransactions', 'Pages.StockTransactions', 'flaticon-more', '/app/main/stockTransactions/stockTransactions'),
                new AppMenuItem('StockHandlings', 'Pages.StockHandlings', 'flaticon-more', '/app/main/stockHandlings/stockHandlings'),
                new AppMenuItem('FinancialYears', 'Pages.FinancialYears', 'flaticon-more', '/app/main/financialYears/financialYears'),

            ]),
            new AppMenuItem('BasicInformation', '', 'flaticon-information', '', [
                new AppMenuItem('GeographicalInformation', 'Pages.GeographicalInformation', 'flaticon-earth-globe', '/app/main/geographical-information/geographical-information'),
                new AppMenuItem('Currencies', 'Pages.Currencies', 'flaticon-more', '/app/main/currencies/currencies'),
                new AppMenuItem('Jobs', 'Pages.Jobs', 'flaticon-more', '/app/main/jobs/jobs'),
                new AppMenuItem('EducationDegrees', 'Pages.EducationDegrees', 'flaticon-more', '/app/main/educationDegrees/educationDegrees'),
                new AppMenuItem('Universities', 'Pages.Universities', 'flaticon-more', '/app/main/universities/universities'),
                new AppMenuItem('EducationFields', 'Pages.EducationFields', 'flaticon-more', '/app/main/educationFields/educationFields'),
                new AppMenuItem('HealthStatuses', 'Pages.HealthStatuses', 'flaticon-more', '/app/main/healthStatuses/healthStatuses'),
                new AppMenuItem('RespectPrefixes', 'Pages.RespectPrefixes', 'flaticon-more', '/app/main/respectPrefixes/respectPrefixes'),
                new AppMenuItem('Banks', 'Pages.Banks', 'flaticon-more', '/app/main/banks/banks'),
                new AppMenuItem('BankAccounts', 'Pages.BankAccounts', 'flaticon-more', '/app/main/bankAccounts/bankAccounts'),
                // new AppMenuItem('PosUsers', 'Pages.PosUsers', 'flaticon-more', '/app/main/posUsers/posUsers'),
                new AppMenuItem('Poses', 'Pages.Poses', 'flaticon-more', '/app/main/poses/poses'),
                new AppMenuItem('SupportiveOrganizations', 'Pages.SupportiveOrganizations', 'flaticon-more', '/app/main/supportiveOrganizations/supportiveOrganizations'),
                new AppMenuItem('Branches', 'Pages.Branches', 'flaticon-more', '/app/main/branches/branches'),
                new AppMenuItem('GroupSubgroups', 'Pages.GroupSubgroups', 'flaticon2-group', '/app/main/groupSubgroups/groupSubgroups'),
            ]),
            new AppMenuItem('PersonsInformation', 'Pages.Contacts' || 'Pages.LegalContacts' || 'Pages.Families', 'flaticon-user', '', [
                new AppMenuItem('Contacts', 'Pages.Contacts', 'flaticon-more', '/app/main/contacts/contacts'),
                new AppMenuItem('LegalContacts', 'Pages.LegalContacts', 'flaticon-more', '/app/main/legalContacts/legalContacts'),

                new AppMenuItem('FamilyInformation', '', 'flaticon-user', '', [
                    new AppMenuItem('Families', 'Pages.Families', 'flaticon-more', '/app/main/families/families'),
                    new AppMenuItem('FamilyTypes', 'Pages.FamilyTypes', 'flaticon-more', '/app/main/familyTypes/familyTypes'),
                    new AppMenuItem('IncomeOutcomes', 'Pages.IncomeOutcomes', 'flaticon-more', '/app/main/incomeOutcomes/incomeOutcomes'),
                    new AppMenuItem('FamilyMembersRoles', 'Pages.Families', 'flaticon-more', '/app/main/familyMembersRoles/familyMembersRoles'),
                ]),
                new AppMenuItem('PersonInquiries', 'Pages.PersonInquiries', 'flaticon-more', '/app/main/personInquiries/personInquiries')
            ]),
            new AppMenuItem('Plans', '', 'flaticon-app', '', [
                new AppMenuItem('Plans', 'Pages.PlanConsts', 'flaticon-more', '/app/main/planConsts/plans'),
                new AppMenuItem('PlanCategories', 'Pages.PlanCategories', 'flaticon-more', '/app/main/planCategories/planCategories'),
                new AppMenuItem('SacrificeTypes', 'Pages.SacrificeTypes', 'flaticon-more', '/app/main/sacrificeTypes/sacrificeTypes'),
                new AppMenuItem('SlaughterAgents', 'Pages.SlaughterAgents', 'flaticon-more', '/app/main/slaughterAgents/slaughterAgents'),
                new AppMenuItem('Sources', 'Pages.Sources', 'flaticon-more', '/app/main/sources/sources'),
                new AppMenuItem('Consumes', 'Pages.Consumes', 'flaticon-more', '/app/main/consumes/consumes'),
                new AppMenuItem('ConsumesAndSources', 'Pages.ConsumesAndSources' && 'Pages.Sources', 'flaticon-more', '/app/main/consumesAndSources/consumesAndSources'),
                new AppMenuItem('BaseTimes', 'Pages.BaseTimes', 'flaticon-more', '/app/main/baseTimes/baseTimes'),
                new AppMenuItem('Wages', 'Pages.Wages', 'flaticon-more', '/app/main/wages/wages'),
                new AppMenuItem('UserEntities', 'Pages.UserEntities', 'flaticon-more', '/app/main/userEntites/userEntities'),
                new AppMenuItem('Comments', 'Pages.Comments', 'flaticon-comment', '/app/main/comments/comments'),
            ]),

            new AppMenuItem('Location', '', 'flaticon2-location', '', [
                new AppMenuItem('LocationGroups', 'Pages.LocationGroups', 'flaticon-more', '/app/main/locationGroups/locationGroups'),
                new AppMenuItem('LocationTypes', 'Pages.LocationTypes', 'flaticon-more', '/app/main/locationTypes/locationTypes'),
                new AppMenuItem('Locations', 'Pages.Locations', 'flaticon-more', '/app/main/locations/locations'),
            ]),
            new AppMenuItem('Ceremony', '', 'flaticon-calendar-with-a-clock-time-tools', '', [
                new AppMenuItem('EventTypes', 'Pages.EventTypes', 'flaticon-more', '/app/main/eventTypes/eventTypes'),
                new AppMenuItem('Ceremonies', 'Pages.Ceremonies', 'flaticon-more', '/app/main/ceremonies/ceremonies'),
            ]),
            new AppMenuItem('Deceaseds', 'Pages.Deceaseds', 'flaticon2-user', '/app/main/deceaseds/deceaseds'),
            new AppMenuItem('CondolenceMessages', 'Pages.CondolenceMessages', 'flaticon-comment', '/app/main/condolenceMessages/condolenceMessages'),

            new AppMenuItem('Bills', 'Pages.Bills', 'flaticon-folder-1', '', [
                new AppMenuItem('FlowerAndSacrificeBills', 'Pages.Bills', 'flaticon-more', '/app/main/bills/fsbills'),
                new AppMenuItem('CharityBills', 'Pages.Bills', 'flaticon-more', '/app/main/bills/cbills'),
            ]),
            new AppMenuItem('PlanBills', 'Pages.PlanBills', 'flaticon2-time', '/app/main/planBills/planBills'),


            new AppMenuItem('Reports', '', 'flaticon-edit', '', [
                new AppMenuItem('SMSReports', 'Pages.Reports.SmsReport', 'flaticon-more', '/app/main/reports/SMS-report'),
                new AppMenuItem('DailyFlowerReport', 'Pages.Reports.DailyFlowerReport', 'flaticon-more', '/app/main/reports/dailyFlowerReport/daily-flower-report'),
                new AppMenuItem('UserReport', 'Pages.Reports.UserReport', 'flaticon-more', '/app/main/reports/userReport/user-report'),
                new AppMenuItem('AllBills', 'Pages.Reports.AllBills', 'flaticon-more', '/app/main/reports/billReport/bill-report'),
                new AppMenuItem('SacrificeReport', 'Pages.Reports.SacrificeReport', 'flaticon-more', '/app/main/reports/sacrificeReport/sacrifice-report'),
                new AppMenuItem('VirtualPaymentReport', 'Pages.Reports.VirtualPaymentReport', 'flaticon-more', '/app/main/reports/virtualsReport/virtuals-report'),
                new AppMenuItem('PlanParticipationReport', 'Pages.Reports.EkramReport', 'flaticon-more', '/app/main/reports/ekramReport/ekram-report'),
                new AppMenuItem('Payments', 'Pages.Reports.Payment', 'flaticon-more', '/app/main/payments/payments'),
                new AppMenuItem('DeliveryToContactFlowers', 'Pages.FollowUps' && 'Pages.Bills', 'flaticon-more', '/app/main/reports/billFollowUpsReport/bill-followUps-report'),

                // new AppMenuItem('CashOuts', 'Pages.CashOuts', 'flaticon-more', '/app/main/cashOuts/cashOuts'),
            ]),
            new AppMenuItem('SettingsAndTemplate', '', 'flaticon-cogwheel', '', [
                new AppMenuItem('ThemTemplates', 'Pages.ThemTemplates', 'flaticon-more', '/app/main/themTemplates/themTemplates'),
                new AppMenuItem('GeneralSettings', 'Pages.GeneralSettings', 'flaticon-more', '/app/main/generalSettings/generalSettings'),
                new AppMenuItem('CardTemplates', 'Pages.CardTemplates', 'flaticon-more', '/app/main/cardTemplates/cardTemplates'),
                new AppMenuItem('TermMappings', 'Pages.TermMappings', 'flaticon-more', '/app/main/termMappings/termMappings'),
                new AppMenuItem('SMSServiceConfigs', 'Pages.SMSServiceConfigs', 'flaticon-more', '/app/main/smsServiceConfigs/smsServiceConfigs'),
            ]),

            new AppMenuItem('Administration', '', 'flaticon-interface-8', '', [
                new AppMenuItem('OrganizationUnits', 'Pages.Administration.OrganizationUnits', 'flaticon-map', '/app/admin/organization-units'),
                new AppMenuItem('Roles', 'Pages.Administration.Roles', 'flaticon-suitcase', '/app/admin/roles'),
                new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),
                new AppMenuItem('Languages', 'Pages.Administration.Languages', 'flaticon-tabs', '/app/admin/languages'),
                new AppMenuItem('AuditLogs', 'Pages.Administration.AuditLogs', 'flaticon-folder-1', '/app/admin/auditLogs'),
                new AppMenuItem('Maintenance', 'Pages.Administration.Host.Maintenance', 'flaticon-lock', '/app/admin/maintenance'),
                new AppMenuItem('Subscription', 'Pages.Administration.Tenant.SubscriptionManagement', 'flaticon-refresh', '/app/admin/subscription-management'),
                new AppMenuItem('VisualSettings', 'Pages.Administration.UiCustomization', 'flaticon-medical', '/app/admin/ui-customization'),
                new AppMenuItem('Settings', 'Pages.Administration.Host.Settings', 'flaticon-settings', '/app/admin/hostSettings'),
                new AppMenuItem('Settings', 'Pages.Administration.Tenant.Settings', 'flaticon-settings', '/app/admin/tenantSettings'),

            ]),
            new AppMenuItem('DemoUiComponents', 'Pages.DemoUiComponents', 'flaticon-shapes', '/app/admin/demo-ui-components')
        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {

        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === '' || subMenuItem.permissionName === null || subMenuItem.permissionName && this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                return true;
            } else if (subMenuItem.items && subMenuItem.items.length) {
                return this.checkChildMenuItemPermission(subMenuItem);
            }
        }

        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' && this._appSessionService.tenant && !this._appSessionService.tenant.edition) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach(menuItem => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach(subMenu => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }
}
